import { FC, SVGProps } from 'react';

export const ExclamationIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
		<path
			d='M11.5 21C16.4706 21 20.5 16.9706 20.5 12C20.5 7.02944 16.4706 3 11.5 3C6.52944 3 2.5 7.02944 2.5 12C2.5 16.9706 6.52944 21 11.5 21Z'
			stroke='currentColor'
			strokeOpacity='0.6'
			strokeWidth='2'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M11.5 16H11.51V16.01H11.5V16Z'
			stroke='currentColor'
			strokeOpacity='0.6'
			strokeWidth='3'
			strokeLinejoin='round'
		/>
		<path
			d='M11.5 12V8'
			stroke='currentColor'
			strokeOpacity='0.6'
			strokeWidth='2'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);
